import { render } from "./Aside_v1.vue?vue&type=template&id=c0870226&scoped=true&ts=true"
import script from "./Aside_v1.vue?vue&type=script&lang=ts"
export * from "./Aside_v1.vue?vue&type=script&lang=ts"

import "./Aside_v1.vue?vue&type=style&index=0&id=c0870226&scoped=true&lang=css"

import exportComponent from "D:\\project\\CDM_QR-Access-Control-System-3\\DoorWebApp_Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0870226"]])

export default __exports__